module.exports = __webpack_public_path__ + "01_long_gold.aad0f057.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/mama/layer5/01_long_gold.png
// module id = MODu
// module chunks = 0